import { render } from "./CategoryTree2IconShow.vue?vue&type=template&id=aa20986a&scoped=true"
import script from "./CategoryTree2IconShow.vue?vue&type=script&lang=js"
export * from "./CategoryTree2IconShow.vue?vue&type=script&lang=js"

import "./CategoryTree2IconShow.vue?vue&type=style&index=0&id=aa20986a&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa20986a"],['__file',"src/views/h5/common/sys/miniProgram/setting/component/CategoryTree2IconShow.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "aa20986a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('aa20986a', __exports__)) {
    api.reload('aa20986a', __exports__)
  }
  
  module.hot.accept("./CategoryTree2IconShow.vue?vue&type=template&id=aa20986a&scoped=true", () => {
    api.rerender('aa20986a', render)
  })

}


export default __exports__